module.exports = __webpack_public_path__ + "assets/d8e6e0ffd5c26ca5847bd8225ba33709.png";